import {
  SHOW_SNACK,
  HIDE_SNACK,
  START_OFFLINE,
  END_OFFLINE,
  START_FETCHING,
  END_FETCHING,
} from "../actions/app/types";

const initialSnack = {
  message: undefined,
  messageType: undefined,
  delay: undefined,
};

export const initialState = {
  isFetching: false,
  isOffline: !window.navigator.onLine,
  snack: {
    ...initialSnack,
  },
};

const app = (state = initialState, action) => {
  switch (action.type) {
    case START_FETCHING:
      return { ...state, isFetching: true };
    case END_FETCHING:
      return { ...state, isFetching: false };
    case START_OFFLINE:
      return { ...state, isOffline: true };
    case END_OFFLINE:
      return { ...state, isOffline: false };
    case SHOW_SNACK:
      return {
        ...state,
        snack: {
          message: action.message,
          messageType: action.messageType || null,
          delay: action.delay || null,
          i18n: action.i18n || null,
        },
      };
    case HIDE_SNACK:
      return {
        ...state,
        snack: { ...initialSnack },
      };
    default:
      return state;
  }
};

export default app;
